// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6faa7309","516":"1b6e1d67","651":"0be69831"}[chunkId] + ".chunk.js";
};